/* <fitpod-product>: Fitpod buy area. Colour (and any other option) radios pick the variant:
   updates the hidden variant id, price (Swiss format), stock line, button state, lead image and the URL.
   No cart drawer: "Add to bag" submits Shopify's product form and goes to the bag page. */
class FitpodProduct extends HTMLElement {
  connectedCallback() {
    const data = this.querySelector("script[data-variants]");
    if (!data) return;
    this.variants = JSON.parse(data.textContent);
    this.addEventListener("change", (e) => { if (e.target.matches("[data-option]")) this.update(); });
  }
  selected() {
    return [...this.querySelectorAll("fieldset[data-option-index]")].map((f) => {
      const c = f.querySelector("input:checked");
      return c ? c.value : null;
    });
  }
  format(cents) {
    const lang = (document.documentElement.lang || "en").slice(0, 2);
    const francs = Math.floor(cents / 100).toString();
    const rappen = String(cents % 100).padStart(2, "0");
    const sep = lang === "fr" ? " " : "’";
    const grouped = francs.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return lang === "fr" ? grouped + "." + rappen + " CHF" : "CHF " + grouped + "." + rappen;
  }
  update() {
    const opts = this.selected();
    const v = this.variants.find((x) => x.options.every((o, i) => o === opts[i]));
    const id = this.querySelector("input[name=id]");
    const btn = this.querySelector("[data-add-button]");
    const label = this.querySelector("[data-add-label]");
    this.querySelectorAll("fieldset[data-option-index]").forEach((f, i) => {
      const cur = f.querySelector("[data-option-current]");
      if (cur) cur.textContent = opts[i] || "";
    });
    if (!v) {
      if (btn) { btn.disabled = true; if (label) label.textContent = btn.dataset.unavailable; }
      return;
    }
    if (id) id.value = v.id;
    const price = this.querySelector("[data-price]");
    if (price && this.dataset.currency === "CHF") price.textContent = this.format(v.price);
    this.querySelectorAll("[data-stock]").forEach((el) => { el.hidden = el.dataset.stock !== (v.available ? "in" : "out") || !v.tracked; });
    if (btn) {
      btn.disabled = !v.available;
      if (label) label.textContent = v.available ? btn.dataset.add : btn.dataset.soldOut;
    }
    if (v.media) {
      // Show the variant's image in the gallery carousel (order stays as in admin).
      const slides = [...this.querySelectorAll("[data-slide][data-media-id]")];
      const index = slides.findIndex((el) => el.dataset.mediaId === String(v.media));
      const carousel = this.querySelector("fitpod-carousel");
      if (carousel && carousel.go && index >= 0) carousel.go(index);
    }
    const url = new URL(window.location.href);
    url.searchParams.set("variant", v.id);
    window.history.replaceState({}, "", url.toString());
  }
}
if (!customElements.get("fitpod-product")) customElements.define("fitpod-product", FitpodProduct);
